import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { CatalogApp } from "./CatalogApp";
import "../src/i18n";
import "../src/index.css";

/**
 * The root catalog bundle — the public marketing surface served at the apex
 * (delgentic.com) by CatalogStack, separate from the app's CloudFront distro.
 *
 * It renders the SAME components the SPA uses (LandingPage, PrivacyPage,
 * CookiePolicyPage) so the marketing page has exactly one source of truth: edit
 * `src/features/landing/*` and both surfaces move together.
 *
 * There is deliberately NO OIDC provider here. The apex is static and
 * unauthenticated: "Log in" and "Sign up" both mean "go to the app", which runs
 * the Cognito flow and lands the user in the app (Scheda). That is why the legal
 * pages take `onSignup` as a prop rather than reaching for `useAuth()`, and why
 * `LandingPage` takes `onAuth` rather than mounting its own sign-in modal.
 *
 * The routes live in `CatalogApp` so a test can render them; see the invariant
 * documented there.
 */
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <CatalogApp />
    </BrowserRouter>
  </React.StrictMode>,
);
